<template>
    <div :class="`w-full ${showNavbar ? 'max-h-64 ' : 'max-h-0'} duration-500 ease-in overflow-hidden ${isSticky ? 'sticky' : 'fixed'} top-0 z-50`"
        style="box-shadow: 4px 4px 25px 0px rgba(0,0,0,0.1);">
        <div class="w-full h-20 bg-white flex">
            <div class="mx-auto w-full flex px-12 lg:px-24 py-2 items-center" style="max-width: 1400px;">
                <button class="flex items-center" aria-label="Startseite" title="Startseite" @click="$router.push('/')">
                    <div class="bg-[#005ebc] px-3 py-1.5 rounded-lg flex items-center group/icon">
                        <img src="@/assets/logo-minimal.svg" class="h-9" draggable="false"
                            alt="Logo von kirchspielrastenberg.de">
                        <div
                            class="text-white flex flex-col items-start pl-2 overflow-hidden">
                            <p class="font-thin text-[1.1rem]">Kirchspiel</p>
                            <p class="font-bold text-[.84rem] -mt-1 ml-0.5">Rastenberg</p>
                        </div>
                    </div>

                </button>
                <div class="ml-auto gap-3 min-[1100px]:flex hidden text-sm text-black font-normal">
                    <template v-for="i in nav">
                        <button class="px-4 py-2 rounded-md group flex items-center gap-1"
                            @click="() => { if (i.path) $router.push(i.path) }" :data-dropdown-toggle="i.toggle">
                            <p :style="`width: ${i.label.length * 9}px;`" class="group-hover:font-bold duration-100">{{
        i.label }}</p>
                            <svg v-if="i.toggle" class="w-5 h-5 group-hover:stroke-2 duration-100" aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                                viewBox="0 0 24 24">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                    d="m19 9-7 7-7-7" />
                            </svg>
                        </button>
                    </template>
                </div>
                <button class="p-2 rounded-md ml-auto flex min-[1100px]:hidden gap-2 items-center hover:bg-black/10 p-3" id="dropdownDefaultButton"
                    data-dropdown-toggle="dropdown" data-dropdown-offset-skidding="-100"
                    @click="mobileExpandedDropdown = 0;">
                    <svg class="size-6 rounded-lg " aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                        viewBox="0 0 24 24">
                        <path fill-rule="evenodd"
                            d="M4.857 3A1.857 1.857 0 0 0 3 4.857v4.286C3 10.169 3.831 11 4.857 11h4.286A1.857 1.857 0 0 0 11 9.143V4.857A1.857 1.857 0 0 0 9.143 3H4.857Zm10 0A1.857 1.857 0 0 0 13 4.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 9.143V4.857A1.857 1.857 0 0 0 19.143 3h-4.286Zm-10 10A1.857 1.857 0 0 0 3 14.857v4.286C3 20.169 3.831 21 4.857 21h4.286A1.857 1.857 0 0 0 11 19.143v-4.286A1.857 1.857 0 0 0 9.143 13H4.857Zm10 0A1.857 1.857 0 0 0 13 14.857v4.286c0 1.026.831 1.857 1.857 1.857h4.286A1.857 1.857 0 0 0 21 19.143v-4.286A1.857 1.857 0 0 0 19.143 13h-4.286Z"
                            clip-rule="evenodd" />
                    </svg>
                    <p>Menu</p>
                </button>
            </div>
        </div>
    </div>

    <!-- THEMENWELT -->
    <div id="themenwelt_dropdown"
        class="hidden bg-gray-800 w-60 divide-y divide-white/50 rounded-md shadow-md flex flex-col z-50">
        <p class="text-sm text-white px-4 pt-4 pb-2 text-left">Themenwelt</p>
        <div class="flex flex-col py-2 font-thin">
            <button v-for="i in topics_nav" :key="i" class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left" @click="$router.push(i.path)">{{ i.label }}</button>
        </div>
    </div>

    <!-- KIRCHEN -->
    <div id="kirchen_dropdown"
        class="hidden bg-gray-800 w-60 divide-y divide-white/50 rounded-md shadow-md flex flex-col z-50">
        <p class="text-sm text-white px-4 pt-4 pb-2 text-left">Kirchen</p>
        <div class="flex flex-col py-2 font-thin">
            <button v-for="i in churches_nav" :key="i" class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left" @click="$router.push(i.path)">{{ i.label }}</button>
        </div>
    </div>



    <div id="dropdown" class="hidden bg-gray-800 w-[300px] divide-y divide-white/50 rounded-md shadow-md flex flex-col z-50">
        <p class="text-sm text-white px-4 pt-4 pb-2 text-left">Menu</p>
        <div class="flex flex-col py-2 font-thin">
            <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left" @click="$router.push('/')">Startseite</button>
            <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left flex items-center gap-2"
                @click="{ mobileExpandedDropdown = mobileExpandedDropdown != 1 ? 1 : 0; }">
                Unsere Kirchen
                <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m19 9-7 7-7-7" />
                </svg>
            </button>
            <div
                :class="`py-2 my-2 flex-col bg-white/5 duration-200 overflow-hidden ${mobileExpandedDropdown == 1 ? 'flex max-h-[1000px]' : 'hidden max-h-0 '}`">
                <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left" @click="$router.push(i.path)"
                    v-for="i in churches_nav" :key="i">{{ i.label }}</button>
            </div>
            <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left flex items-center gap-2"
                @click="{ mobileExpandedDropdown = mobileExpandedDropdown != 2 ? 2 : 0; }">
                Themenwelt
                <svg class="w-4 h-4 mb-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                    fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="m19 9-7 7-7-7" />
                </svg>
            </button>
            <div
                :class="`py-2 my-2 flex-col bg-white/5 duration-200 overflow-hidden ${mobileExpandedDropdown == 2 ? 'flex max-h-[1000px]' : 'hidden max-h-0 '}`">
                <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left" @click="$router.push(i.path)" v-for="i in topics_nav"
                    :key="i">{{ i.label }}</button>
            </div>
            <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left"
                @click="$router.push({ path: '/', hash: '#butterfly' })">Schmetterling</button>
            <button class="text-white hover:bg-card-white/10 px-4 py-2 
                hover:bg-card-default/10 duration-200 text-left"
                @click="$router.push({ path: '/', hash: '#contact' })">Kontakt</button>
        </div>
    </div>
</template>

<script>
import { initDropdowns } from 'flowbite';

export default {
    name: "Navbar",
    data() {
        return {
            mobileExpandedDropdown: 0,
            showNavbar: false,
            isSticky: false,
            nav: [
                {
                    label: "Startseite",
                    path: "/"
                },
                {
                    label: "Unsere Kirchen",
                    toggle: "kirchen_dropdown"
                },
                {
                    label: "Themenwelt",
                    toggle: "themenwelt_dropdown"
                },
                {
                    label: "Schmetterling",
                    path: "/#butterfly"
                },
                {
                    label: "Kontakt",
                    path: "/#contact"
                },
            ],
            topics_nav: [
                {
                    label: "Gottesdienst",
                    path: "/themenwelt/gottesdienst"
                },
                {
                    label: "Pfadfinder",
                    path: "/themenwelt/pfadfinder"
                },
                {
                    label: "Jugendliche",
                    path: "/themenwelt/jugendliche"
                },
                {
                    label: "Gemeindenachmittag",
                    path: "/themenwelt/gemeindenachmittag",
                },
                {
                    label: "Frauenkreis",
                    path: "/themenwelt/frauenkreis"
                }
            ],
            churches_nav: [
                {
                    label: "Rastenberg",
                    path: "/kirchen/rastenberg"
                },
                {
                    label: "Roldisleben",
                    path: "/kirchen/roldisleben"
                },
                {
                    label: "Olbersleben",
                    path: "/kirchen/olbersleben"
                },
                {
                    label: "Guthmannshausen",
                    path: "/kirchen/guthmannshausen",
                },
                {
                    label: "Eßleben",
                    path: "/kirchen/essleben"
                },
                {
                    label: "Großneuhausen",
                    path: "/kirchen/großneuhausen"
                },
                {
                    label: "Teutleben",
                    path: "/kirchen/teutleben"
                },
                {
                    label: "Mannstedt",
                    path: "/kirchen/mannstedt"
                },
            ]
        }
    },
    mounted() {
        initDropdowns();
    },
    methods: {
        scrollListener() {
            let heroSection = document.querySelector('#hero');
            this.isSticky = heroSection == undefined;
            this.showNavbar = window.scrollY >= (heroSection?.offsetHeight || 0);
        }
    },
    created() {
        window.addEventListener('scroll', this.scrollListener);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scrollListener);
    },
    watch: {
        $route() {
            setTimeout(() => {
                this.scrollListener();
            }, 100);

        }
    }
}
</script>